import React, {Fragment, useEffect, useState} from "react";
import {
    Autocomplete,
    Button,
    Checkbox,
    Chip,
    FormControl,
    FormControlLabel, FormLabel,
    Grid, InputLabel,
    ListSubheader, MenuItem, Select,
    TextField,
    RadioGroup,
    Radio
} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

import {isEmpty} from "../../core/utils/commonUtils";
import {useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import {useGetAllParametersQuery} from "../../core/api/parameters";
import StyledFormGroup from "../../components/StyledFormGroup";
import Loading from "../../components/Common/Loading";

const NUMBER_VERSION_OPERATORS = [
    'gt', 'lt', 'ge', 'le'
];
export const POSSIBLE_OPERATORS: Map = new Map(Object.entries({
    'NUMBER_RANGE': NUMBER_VERSION_OPERATORS,
    'VERSION_RANGE': NUMBER_VERSION_OPERATORS,
    'INCLUDE': 'include',
    'INCLUDE_ANY': 'includeAny',
    'INCLUDE_ALL': 'includeAll',
    'EXCLUDE_ANY': 'excludeAny',
    'EXCLUDE_ALL': 'excludeAll',
    'EXCLUDE': 'exclude',
    'OFFER_IN_PROFILE': 'offerInProfile',
    'OFFER_NOT_IN_PROFILE': 'offerNotInProfile',
    'PROFILE_OFFSET': 'profileOffset',
    'OFFER_INACTIVE': 'offerInactiveRule',
    'TYPE_INACTIVE': 'offerTypeInactiveRule',
    'TAG_INACTIVE': 'offerTagInactiveRule',
    'TAG_NOT_IN_PROFILE': 'offerTagNotInProfileRule',
    'TAGS_IN_PROFILE': 'offerTagsInProfileRule',
}));

export default function AudienceForm(props) {
    const sourceMode = useSelector((state) => state.data.SourceMode);
    const [searchParams, setSearchParams] = useSearchParams();
    const [showAdvancedSettings, setShowAdvancedSettings] = useState(false);
    const [selectedAbTestCohortValue, setSelectedAbTestCohortValue] = useState({});

    const OFFERS_PARAMETERS = [
        'offers_in_profile', 'offers_not_in_profile'
    ]
    const OFFSET_PARAMETERS = ['profile_offset_from_end', 'profile_offset_from_start']
    const [currentAudienceIndex, setCurrentAudienceIndex] = useState(0);
    const {
        data: params,
        status: paramsStatus,
        isLoading,
        isError,
        error
    } = useGetAllParametersQuery()

    useEffect(() => {
        if(paramsStatus === 'fulfilled' && props.currentAbTest.audiences[currentAudienceIndex] == undefined) {
            console.log(currentAudienceIndex + ' not found')
        }
        if (paramsStatus === 'fulfilled' && props.currentAbTest.audiences[currentAudienceIndex]?.parameters[0]?.parameterData.name === undefined) {
            // props.handleParameterDataChange(params, params[0].name, 0, currentAudienceIndex)
        }
    }, [paramsStatus])

    const getCurrentParam = (campaign, paramIndex, currentAudienceIndex) => {
        return campaign?.audiences[currentAudienceIndex].parameters[paramIndex]
    }

    const getCurrentParamAllowedValues = (campaign, paramIndex, currentAudienceIndex, defaultParameters) => {
        let param = getCurrentParam(campaign, paramIndex, currentAudienceIndex);
        if (!param.parameterData.name) return [];
        let paramObj = defaultParameters.filter(p => p.name === param.parameterData.name)
        if(paramObj.length == 0) return []
        return paramObj[0].allowedValues;
    }

    const getCurrentParamName = (paramIndex) => {
        const currentParam = getCurrentParam(props.currentAbTest, paramIndex, currentAudienceIndex);
        return currentParam.parameterData.name
    }
    const getCurrentParamOperators = (params, paramName) => {
        if (!params || !paramName) return []
        let currentParameter = params.filter(p => p.name === paramName);
        if(currentParameter.length == 0) return []
        currentParameter = currentParameter[0];
        return currentParameter.allowedRules.flatMap(rule => POSSIBLE_OPERATORS.get(rule))
    }

    const handleDecrementCurrentAudienceIndex = (index) => {
        if (index > currentAudienceIndex) {
            return
        }
        if (currentAudienceIndex > 1) {
            setCurrentAudienceIndex(currentAudienceIndex - 1);
        } else {
            setCurrentAudienceIndex(0)
        }
    }

    const isVersionNumericParameter = (paramIndex) => {
        const result = getCurrentParam(props.currentAbTest, paramIndex, currentAudienceIndex).hasOwnProperty('fromIncl') ||
            getCurrentParam(props.currentAbTest, paramIndex, currentAudienceIndex).hasOwnProperty('toIncl');
        return result;
    }

    const isOffersParameter = (paramIndex) => {
        const currentParam = getCurrentParam(props.currentAbTest, paramIndex, currentAudienceIndex);
        return OFFERS_PARAMETERS.includes(currentParam?.parameterData?.name);
    }
    const isOffsetParameter = (paramIndex) => {
        const currentParam = getCurrentParam(props.currentAbTest, paramIndex, currentAudienceIndex);
        return OFFSET_PARAMETERS.includes(currentParam?.parameterData?.name);
    }

    const hasError = (audienceIndex, paramIndex, errorType) => {
        let typeErrors = props.errorFields.filter(e => e.hasOwnProperty(errorType));
        if (typeErrors.length === 0) return false;
        typeErrors = typeErrors[0]

        return typeErrors[errorType].filter(e => e.audienceIndex === audienceIndex &&
            e.paramIndex === paramIndex
        ).length > 0
    }

    function getOffsetInputComponentOrDefault(paramIndex, currentAudienceIndex) {
        const currentParam = getCurrentParam(props.currentAbTest, paramIndex, currentAudienceIndex)
        if (!isOffsetParameter(paramIndex)) {
            if(['includeAny','excludeAll','excludeAny','includeAll'].includes(currentParam.operator) ) {
                return <><Autocomplete
                    fullWidth
                    limitTags={1}
                    multiple

                    componentsProps={{ popper: { style: { width: 'fit-content' } } }}
                    value={currentParam.paramValue ?
                        currentParam: []}

                    onChange={(event, value) =>
                        props.handleParameterValueChange(value, paramIndex, currentAudienceIndex)}
                    // onBlur={(event) => {
                    //     const currentValue = event.target.value.trim();
                    //     const currentParamValue = getCurrentParam(props.currentAbTest, paramIndex, currentAudienceIndex).paramValue || [];
                    //
                    //     if (currentValue && !currentParamValue.includes(currentValue)) {
                    //         const updatedValue = [...currentParamValue, currentValue];
                    //         props.handleParameterValueChange(updatedValue, paramIndex, currentAudienceIndex);
                    //         event.target.value = '';
                    //     }
                    // }}
                    renderInput={
                        params => (
                            <TextField
                                error={!!getCurrentParam(props.currentAbTest, paramIndex, currentAudienceIndex).valueError}
                                {...params}
                                id="value"
                                name="value"
                                label="Value (press enter to split)"
                                variant="outlined"


                            />
                        )
                    }>

                </Autocomplete></>
            }
            return <TextField
                fullWidth
                // error={!!getCurrentParam(props.currentAbTest, paramIndex, currentAudienceIndex).valueError}
                error={hasError(currentAudienceIndex, paramIndex, 'paramValueError')}
                id="value"
                name="value"
                label="Value"
                variant="outlined"
                value={currentParam.paramValue}
                onChange={(e) => props.handleManualInput(e, paramIndex, currentAudienceIndex)}
            />
        }

        return <Grid container>
            <Grid item size={{sm:5}} pr={0.5}>
                <TextField
                    fullWidth
                    error={!!currentParam.offerValueError}
                    id="offerId"
                    name='offerId'
                    label="Offer id"
                    variant="outlined"
                    value={currentParam.offerId}
                    onChange={(e) => props.handleManualInputForOffset(e, 'offerId', paramIndex, currentAudienceIndex)}
                />
            </Grid>
            <Grid item size={{sm:2}} pr={0.5}>
                <FormControl fullWidth variant="outlined" error={!!currentParam.operatorValueError}>
                    <InputLabel id={`operator-label-${paramIndex}-${currentAudienceIndex}`}>Operator</InputLabel>
                    <Select
                        labelId={`operator-label-${paramIndex}-${currentAudienceIndex}`}
                        id="operator"
                        name="operator"
                        value={currentParam.operator}
                        onChange={(e) => props.handleManualInputForOffset(e, 'operator', paramIndex, currentAudienceIndex)}
                        label="Operator"
                        error={isEmpty(currentParam.operator)}

                    >
                        <MenuItem value=""></MenuItem>
                        <MenuItem value="GREATER_THAN">{">"}</MenuItem>
                        <MenuItem value="LESS_THAN">{"<"}</MenuItem>
                    </Select>
                </FormControl>

            </Grid>
            <Grid item size={{sm:5}} pl={0.5}>
                <TextField
                    fullWidth
                    error={!!currentParam.offsetValueError}
                    id="offsetValue"
                    name="offsetValue"
                    label="Offset value (for example PT24H)"
                    variant="outlined"
                    value={currentParam.offset}
                    onChange={(e) => props.handleManualInputForOffset(e, 'offset', paramIndex, currentAudienceIndex)}
                />
            </Grid>
        </Grid>
    }

    const typeError = (value) => {
        return isEmpty(value?.parameterData?.name);
    }

    const filterAbTestCohorts = (parameterName, aIndex, options) => {
        if (parameterName !== 'ab_test_cohort' || isEmpty(selectedAbTestCohortValue[aIndex])) {
            return options;
        }
        return options.filter(o => {
            return o.split(":")[0]===selectedAbTestCohortValue[aIndex]
        })
    }


    const createParameterComponent = (parameters, paramIndex) => {
        return (
            <>
                {params && <Grid item size={3}>
                    <Autocomplete
                        disableClearable={true}
                        options={params}
                        groupBy={(option) => option.isMain ? 'POPULAR' : 'OTHER'}
                        renderGroup={(params) => (
                            <Fragment key={params.key}>
                                <ListSubheader>{params.group}</ListSubheader>
                                {params.children}
                            </Fragment>
                        )}
                        getOptionLabel={(option) => option.name!=undefined?option.name:''}

                        value={getCurrentParam(props.currentAbTest, paramIndex, currentAudienceIndex) != undefined ? getCurrentParam(props.currentAbTest, paramIndex, currentAudienceIndex).parameterData : ''}

                        onChange={(event, value) =>
                            props.handleParameterDataChange(params, value.name, paramIndex, currentAudienceIndex)
                        }
                        renderInput={
                            params => (
                                <TextField
                                    {...params}
                                    id="parameterData"
                                    name="parameterData"
                                    variant="outlined"
                                    label="Requirement"
                                    error={hasError(currentAudienceIndex, paramIndex, 'sameFieldError', 'paramNameError') ||
                                        // typeError(getCurrentParam(props.currentAbTest, paramIndex, currentAudienceIndex))
                                        typeError(props.currentAbTest.audiences[currentAudienceIndex].parameters[paramIndex])}
                                />
                            )
                        }>
                    </Autocomplete>
                </Grid>}
                {!isOffersParameter(paramIndex) && !isOffsetParameter(paramIndex)
                    &&
                    <Grid item size={!isVersionNumericParameter(paramIndex) ? 2 : 8}>
                        {!isVersionNumericParameter(paramIndex) &&
                            <Autocomplete
                                freeSolo={['offer_inactive','type_inactive','tag_inactive','tag_not_in_profile','tags_in_profile'].includes(getCurrentParam(props.currentAbTest, paramIndex, currentAudienceIndex).parameterData.name)}
                                disableClearable={true}
                                options={getCurrentParamOperators(params, getCurrentParamName(paramIndex))}
                                value={getCurrentParam(props.currentAbTest, paramIndex, currentAudienceIndex).operator || ''}
                                onChange={(event, value) =>
                                    props.handleParameterOperatorChange(value, paramIndex, currentAudienceIndex)
                                }
                                renderInput={
                                    params => (
                                        <TextField
                                            {...params}
                                            id="operator"
                                            name="operator"
                                            label="Operator"
                                            variant="outlined"
                                            error={!!getCurrentParam(props.currentAbTest, paramIndex, currentAudienceIndex).operatorError}
                                        />
                                    )
                                }>

                            </Autocomplete>
                        }

                        {/*is version/numeric parameter*/}
                        {isVersionNumericParameter(paramIndex) &&
                            <StyledFormGroup
                                errorFields={props.errorFields}
                                paramIndex={paramIndex}
                                paramName={getCurrentParamName(paramIndex)}
                                currentItem={props.currentAbTest}
                                currentAudienceIndex={currentAudienceIndex}
                                handleParameterValueChange={props.handleParameterValueChange}
                                handleVersionNumericParameterChange={props.handleVersionNumericParameterChange}
                            />
                        }
                    </Grid>}
                {!isVersionNumericParameter(paramIndex) &&
                    <Grid item size={isOffersParameter(paramIndex) || isOffsetParameter(paramIndex) ? 8 : 6}>
                        <Grid container size={12}>
                            {getCurrentParamAllowedValues(props.currentAbTest, paramIndex, currentAudienceIndex, params).length !== 0 ||
                            (['include','exclude','includeAny','excludeAll','excludeAny','includeAll','offerTagInactiveRule','offerTagNotInProfileRule','offerTagsInProfileRule'].includes(getCurrentParam(props.currentAbTest, paramIndex, currentAudienceIndex).operator) )
                                ?
                                <Autocomplete
                                    fullWidth
                                    limitTags={1}
                                    freeSolo={['country','type_inactive','attribution_campaign','tag_inactive','tag_not_in_profile','tags_in_profile','deviceId'].includes(getCurrentParam(props.currentAbTest, paramIndex, currentAudienceIndex).parameterData.name)}
                                    getOptionLabel={(option) => (option ? String(option) : '')}
                                    multiple={getCurrentParam(props.currentAbTest, paramIndex, currentAudienceIndex).parameterData.name !== 'ab_test'}
                                    value={getCurrentParam(props.currentAbTest, paramIndex, currentAudienceIndex).paramValue || []}
                                    options={getCurrentParamAllowedValues(props.currentAbTest, paramIndex, currentAudienceIndex, params) ?
                                        filterAbTestCohorts(
                                            getCurrentParam(props.currentAbTest, paramIndex, currentAudienceIndex).parameterData.name,
                                            currentAudienceIndex,
                                            getCurrentParamAllowedValues(props.currentAbTest, paramIndex, currentAudienceIndex, params)
                                        ) : []}
                                    onChange={(event, value) => {
                                        // Фильтруем пустые значения
                                        const filteredValue = Array.isArray(value)
                                            ? value.filter(item => item !== null && item !== undefined && String(item).trim() !== '')
                                            : value;

                                        if (getCurrentParam(props.currentAbTest, paramIndex, currentAudienceIndex).parameterData.name === 'ab_test_cohort') {
                                            const arrayValue = Array.isArray(filteredValue) ? filteredValue : [filteredValue];
                                            arrayValue.length > 0 ? setSelectedAbTestCohortValue({[currentAudienceIndex] : arrayValue[0].split(":")[0]}) :
                                                setSelectedAbTestCohortValue({[currentAudienceIndex] : ""});
                                        }
                                        props.handleParameterValueChange(filteredValue, paramIndex, currentAudienceIndex);
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === 'Enter') {
                                            const inputValue = event.target.value?.trim();
                                            if (inputValue) {
                                                // Предотвращаем стандартное поведение и добавляем значение вручную
                                                event.preventDefault();
                                                const currentValue = getCurrentParam(props.currentAbTest, paramIndex, currentAudienceIndex).paramValue || [];
                                                if (!currentValue.includes(inputValue)) {
                                                    const newValue = [...currentValue, inputValue];
                                                    props.handleParameterValueChange(newValue, paramIndex, currentAudienceIndex);
                                                    // Очищаем поле ввода
                                                    event.target.value = '';
                                                }
                                            }
                                        }
                                    }}

                                    onInputChange={(event, newInputValue, reason) => {
                                        // Предотвращаем добавление пустых значений при нажатии Enter
                                        if (reason === 'input' && newInputValue.trim() === '') {
                                            return;
                                        }
                                    }}
                                    renderInput={params => (
                                        <TextField
                                            error={!!getCurrentParam(props.currentAbTest, paramIndex, currentAudienceIndex).valueError}
                                            {...params}
                                            id="value"
                                            name="value"
                                            label="Value (press enter to split)"
                                            variant="outlined"
                                        />
                                    )}
                                    renderTags={(tagValue, getTagProps) =>
                                        tagValue.map((option, index) => {
                                            // Не рендерим пустые теги
                                            if (!option || String(option).trim() === '') {
                                                return null;
                                            }
                                            return (
                                                <Chip
                                                    {...getTagProps({ index })}
                                                    key={index}
                                                    label={String(option)}
                                                />
                                            );
                                        }).filter(Boolean)
                                    }
                                /> : getOffsetInputComponentOrDefault(paramIndex, currentAudienceIndex)
                            }

                        </Grid>
                    </Grid>}
                <Grid item size={1} display={'flex'} justifyContent={'start'}>
                    {parameters.length > 1 &&
                        <Button style={{minWidth: '100%'}}
                                variant={'outlined'}
                                color={'error'}
                                onClick={() => props.handleDeleteParams(currentAudienceIndex, paramIndex)}
                        >
                            <DeleteIcon/>
                        </Button>}
                </Grid>
            </>
        )
    }

    const _audiencesWithErrors = () => {

        let set = new Set();

        props.errorFields.forEach(e => {
            for (let field of Object.keys(e)) {
                for (let param of e[field]) {
                    set.add(param.audienceIndex)
                }
            }
        })
        return set;
    }

    return (
        <Fragment>
            <Grid container spacing={3} minWidth={'800px'} className={"test"}>
                <Grid item size={12}>
                    <Grid container size={12} pt={1} spacing={1}>
                        <TextField
                            value={props.audienceTitle.title}
                            label="Title"

                            onChange={(e) => {
                                props.setAudienceTitle({...props.audienceTitle, title: e.target.value})
                            }}>
                        </TextField>
                    </Grid>
                </Grid>


                <Grid item size={12}>
                    <Loading isLoading={isLoading} isError={isError} error={error}>
                        <Grid container spacing={1}>

                            {props.currentAbTest.audiences[currentAudienceIndex]?.parameters && paramsStatus === 'fulfilled' &&
                                props.currentAbTest.audiences[currentAudienceIndex].parameters.map((paramSet, paramIndex) => {
                                    return createParameterComponent(props.currentAbTest.audiences[currentAudienceIndex].parameters, paramIndex)
                                })}
                            <Grid item size={4} pt={2} pl={0}>
                                <Button
                                    variant={'outlined'}
                                    onClick={() => props.handleAddNewParams(currentAudienceIndex)}
                                >
                                    <AddIcon/>
                                </Button>
                            </Grid>
                        </Grid>
                    </Loading>

                </Grid>



            </Grid>

        </Fragment>
    )
}